import './App.css';
import RouteHandler from './Routing/RouteHandler';

function App() {
  return (
    <RouteHandler/>
  );
}

export default App;
